<script>
import { menuItemArr } from "./menu.js";

/**
 * Sidenav component
 */
export default {
  data() {
    return {
      menuItemArr: menuItemArr,
      menuItems: [],
      menuData: null,
      currentMenuId: 0,
      currentParentId: 0,
      cdpUrl: "",
    };
  },
  mounted: function() {
    this.menuItemsShow();
    this.cdpUrl = env.CDP_URL;

    // this.initMenuItems();
  },

  created() {
    // this.menuItemsCycle() // 第一次请求
  },

  watch: {
    $route() {
      this.getItemIndex();
    },
  },

  methods: {
    /**
     * Returns true or false if given menu item has child or not
     * @param item menuItem
     */
    initMenuItems() {
      // setInterval不会清除定时器队列，每重复执行1次都会导致定时器叠加，会导致页面卡死。
      // 但使用setTimeout是自带清除定时器的
      this.getItemIndex();
    },

    menuItemsShow() {
      const user = JSON.parse(this.cookies.getCookie("user"));
      console.log(user);
      // console.log(this.cookies.getCookie('user'))
      // 角色id为1是系统管理员账号、不检测权限 不为1则需要检查权限
      let that = this;
      for (var i = 0; i < this.menuItemArr.length; i++) {
        let labelItem = this.menuItemArr[i];
        if (labelItem.power) {
          if (user.roleId == 1) {
            labelItem.exists = true;
          } else {
            labelItem.exists = that.utils.verifyAuthority(labelItem.power);
          }
          if (labelItem.subItems) {
            if (labelItem.exists) {
              for (let j = 0; j < labelItem.subItems.length; j++) {
                if (labelItem.subItems[j].power) {
                  if (user.roleId == 1) {
                    labelItem.subItems[j].exists = true;
                  } else {
                    labelItem.subItems[j].exists = that.utils.verifyAuthority(
                      labelItem.subItems[j].power
                    );
                  }
                } else {
                  labelItem.subItems[j].exists = true;
                }
              }
            }
          }
        } else {
          labelItem.exists = true;
        }
      }
      this.menuItems = this.menuItemArr;
      console.log(this.menuItemArr, "菜单数据");
      this.$nextTick(function() {
        this.initMenuItems();
      });
    },

    // toggleMenu(event) {
    //   console.log("点击了", event);
    //   // event.currentTarget.nextElementSibling.classList.toggle("mm-show");

    //   event.target.nextElementSibling.nextElementSibling.classList.toggle(
    //     "mm-show"
    //   );
    // },
    toggle(item) {
      this.currentParentId = this.currentParentId == item.id ? 0 : item.id;
    },

    getItemIndex() {
      var itemIndex = 0;
      var parentIndex = 0;
      for (var i = 0; i < this.menuItems.length; i++) {
        let item = this.menuItems[i];
        if (item.link) {
          let indexKey = item.link.indexOf(window.location.pathname);
          if (indexKey != -1) {
            itemIndex = item.id;
            this.currentMenuId = itemIndex;
            this.currentParentId = parentIndex;
            return;
          }
        } else {
          for (var j = 0; j < item.subItems.length; j++) {
            let indexKey = item.subItems[j].link.indexOf(
              window.location.pathname
            );
            if (indexKey != -1) {
              parentIndex = item.id;
              itemIndex = item.subItems[j].id;
              this.currentMenuId = itemIndex;
              this.currentParentId = parentIndex;
              return;
            }
          }
        }
      }
    },

    toLink(item) {
      if (item.link) {
        this.$router.push({
          path: item.link,
        });
      }
    },
  },
};
</script>

<template>
  <!-- ========== Left Sidebar Start ========== -->

  <!--- Sidemenu -->
  <div id="sidebar-menu">
    <!-- Left Menu Start -->
    <ul id="side-menu" class="metismenu list-unstyled">
      <template v-for="item in menuItems">
        <li class="menu-title" v-if="item.isTitle" :key="item.id">
          {{ $t(item.label) }}
        </li>
        <li
          v-if="!item.isTitle && !item.isLayout"
          :key="item.id"
          :class="{ 'mm-active': currentParentId == item.id }"
        >
          <a
            v-show="item.subItems && item.exists"
            href="javascript:void(0);"
            class="is-parent"
            @click="toggle(item)"
            :class="{
              'has-arrow': !item.examineTotal,
              'has-dropdown': item.examineTotal,
            }"
          >
            <i :class="`bx ${item.icon}`" v-if="item.icon"></i>
            <span>{{ $t(item.label) }}</span>
            <!-- <span
              v-if="item.examineTotal > 0"
              :class="`badge rounded-pill bg-danger float-end`"
              >{{ item.examineTotal }}</span
            > -->
          </a>

          <a
            v-show="
              !item.subItems &&
                item.exists &&
                item.link !== '/operationActivity'
            "
            @click="toLink(item)"
            href="javascript:void(0);"
            :class="{ 'mm-active': currentMenuId == item.id }"
            class="side-nav-link-ref"
          >
            <i :class="`bx ${item.icon}`" v-if="item.icon"></i>
            <span>{{ $t(item.label) }}</span>
            <span
              :class="`badge rounded-pill bg-${item.badge.variant} float-end`"
              v-if="item.badge"
              >{{ $t(item.badge.text) }}</span
            >
          </a>

          <a
            v-if="item.link === '/operationActivity'"
            v-show="!item.subItems && item.exists"
            :href="cdpUrl"
            target="_blank"
            class="side-nav-link-a-ref"
          >
            <i :class="`bx ${item.icon}`" v-if="item.icon"></i>
            <span>{{ $t(item.label) }}</span>
          </a>

          <ul
            :class="{
              'mm-show': currentParentId == item.id,
              'mm-collapse': currentParentId != item.id,
            }"
            class="sub-menu"
            aria-expanded="false"
          >
            <li v-for="(subitem, index) of item.subItems" :key="index">
              <template v-if="subitem.exists">
                <a
                  @click="toLink(subitem)"
                  :class="{ 'mm-active': currentMenuId == subitem.id }"
                  class="side-nav-link-a-ref"
                  href="javascript:void(0);"
                >
                  {{ $t(subitem.label) }}
                  <span v-if="subitem.todo" class="untreated-icon">{{
                    subitem.todo
                  }}</span>
                </a>
              </template>
            </li>
          </ul>
        </li>
      </template>
    </ul>
  </div>
  <!-- Sidebar -->
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.metismenu .untreated-icon {
  padding: 0px 4px;
  background: red;
  color: #fff;
  font-size: 12px;
  font-weight: 500;
  border-radius: 20px;
  float: right;
  min-width: 18px;
  margin-top: 2px;
  text-align: center;
}
</style>
